// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file patients/list_patients.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Patient } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.ListPatientsRequest
 */
export class ListPatientsRequest extends Message<ListPatientsRequest> {
  /**
   * Optional search query to filter patients by name, phone, or identifier
   *
   * @generated from field: string search_query = 1;
   */
  searchQuery = "";

  /**
   * Page number for pagination
   *
   * @generated from field: int32 page = 2;
   */
  page = 0;

  /**
   * Number of patients per page
   *
   * @generated from field: int32 page_size = 3;
   */
  pageSize = 0;

  constructor(data?: PartialMessage<ListPatientsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListPatientsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "search_query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPatientsRequest {
    return new ListPatientsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPatientsRequest {
    return new ListPatientsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPatientsRequest {
    return new ListPatientsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListPatientsRequest | PlainMessage<ListPatientsRequest> | undefined, b: ListPatientsRequest | PlainMessage<ListPatientsRequest> | undefined): boolean {
    return proto3.util.equals(ListPatientsRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ListPatientsResponse
 */
export class ListPatientsResponse extends Message<ListPatientsResponse> {
  /**
   * List of patients
   *
   * @generated from field: repeated com.neulink.pharmacy.Patient patients = 1;
   */
  patients: Patient[] = [];

  /**
   * Total number of patients matching the search query
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<ListPatientsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListPatientsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "patients", kind: "message", T: Patient, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPatientsResponse {
    return new ListPatientsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPatientsResponse {
    return new ListPatientsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPatientsResponse {
    return new ListPatientsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListPatientsResponse | PlainMessage<ListPatientsResponse> | undefined, b: ListPatientsResponse | PlainMessage<ListPatientsResponse> | undefined): boolean {
    return proto3.util.equals(ListPatientsResponse, a, b);
  }
}

